import { Box, Button, HStack, Text, useToast } from "@chakra-ui/react";
import { ReactSVG } from "react-svg";
import Coin from "@/assets/design/coin.svg";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser, updateUser } from "@/reducer/userslice";
import type { GenImageSubmitPayload } from "@/types/design";
import { useEffect, useState, useRef } from "react";
import Client4 from "@/services/api/client4";
import { setCurrentImage } from "@/reducer/designslice";
import { Content } from "@/types/content";
import { contentAdd } from "@/reducer/contentSlice";
type Props = {
  totalCoin: number;
  submitParams: GenImageSubmitPayload;
  variant?: "sidebar" | "inline";
};

const GenImageButton = ({ totalCoin, submitParams, variant = "sidebar" }: Props) => {
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const timerRef = useRef<any>();
  const toast = useToast();
  const isInline = variant === "inline";
  const [isLoading, setIsLoading] = useState(false);
  const [taskId, setTaskId] = useState("");
  const taskIdRef = useRef<string>("");
  useEffect(() => {
    taskIdRef.current = taskId;
  }, [taskId]);

  useEffect(() => {
    if (!taskId) return;
    fetchData();
    timerRef.current = setInterval(fetchData, 5000);
    return () => clearInterval(timerRef.current);
  }, [taskId]);

  const fetchData = async () => {
    const result = await Client4.getGenImage(taskIdRef.current);
    if (result.results != null && result.results.length > 0) {
      const content = {
        prompt: result.prompt,
        image_url: result.results[0],
        id: result.id,
        create_at: Date.now()
      };
      
      dispatch(contentAdd(content as Content));
      dispatch(setCurrentImage(content as Content));
      const userInfo = await Client4.getMe();
      dispatch(updateUser(userInfo));

      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        setIsLoading(false);
      }
    }
  };

  const handleGen = async () => {
    if (user && user.id) {
      if (!submitParams.prompt.trim()) {
        toast({
          title: "请输入提示词",
          position: "top",
          status: "warning",
          duration: 1000,
        });
        return;
      }
      const data = {
        userId: user.id,
        modelId: submitParams.modelRealname,
        aspectRatio: submitParams.ratio,
        resolution: submitParams.resolution,
        prompt: submitParams.prompt,
        files: submitParams.files,
        totalCoin: submitParams.totalCoin
      };
      console.log("提交生图参数：", data);
      setIsLoading(true);
      try {
        const result = await Client4.postGenImage(data);
        if (result && result.id) {
          setTaskId(result.id);
          toast({
            title: "生图任务已提交",
            position: "top",
            status: "success",
            duration: 1000,
          });
        } else {
          throw new Error("生图任务提交失败");
        }
      } catch (error) {
        toast({
          title: "生图任务提交失败",
          position: "top",
          status: "error",
          duration: 1000,
        });
      }
      return;
    }

    toast({
      title: "请先登录系统",
      position: "top",
      status: "error",
      duration: 1000,
    });
  };

  return (
    <Box position="relative">
      <Button borderRadius={isInline ? "10px" : "0px"} w={isInline ? "160px" : "170px"} bgColor="#496AE1" _hover={{ opacity: 0.8 }} color="white" h={isInline ? "36px" : "40px"} fontSize={isInline ? "13px" : "14px"} px={isInline ? "14px" : undefined} onClick={handleGen} isLoading={isLoading} loadingText="生图中...">
        <HStack spacing="6px">
          <Text>开始生图</Text>
          <ReactSVG src={Coin} />
          <Text>-{totalCoin}</Text>
        </HStack>
      </Button>
    </Box>
  );
};

export default GenImageButton;
